import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { absUrl } from "@/config/site";
import { JsonLd } from "./JsonLd";

export const Breadcrumbs = ({ items, light = false }) => {
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: absUrl(it.path),
    })),
  };
  return (
    <nav aria-label="Sayfa yolu" className={`text-sm ${light ? "text-white/70" : "text-muted"}`} data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.path} className="flex items-center gap-1.5">
              {last ? (
                <span aria-current="page" className="text-gold font-medium">{it.label}</span>
              ) : (
                <Link to={it.path} className="hover:text-gold transition-colors">{it.label}</Link>
              )}
              {!last && <ChevronRight size={14} aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
      <JsonLd id="breadcrumbs" data={data} />
    </nav>
  );
};
